module.exports = __webpack_public_path__ + "img/mobile_1.f2c61ad3.jpg";